import {
  IconDetails,
  IconEdit,
  IconMinus,
  IconPlus,
  IconTrash,
} from "@tabler/icons-react";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import React from "react";
import { Dropdown, Table } from "react-bootstrap";
import { formatNumber, formatPrice } from "utils/utils";

const ProductTable = ({
  products,
  onEdit,
  onDelete,
  Pagination,
  handleAddStock,
  handleReduceStock,
  handleDetailHistory,
}) => {
  return (
    <div className="table-responsive">
      <Table striped bordered hover size="sm" className="align-middle">
        <thead>
          <tr>
            <th>No</th>
            <th>Image</th>
            <th>Name</th>
            <th>Category</th>
            <th>min_price</th>
            <th>Price</th>
            <th>Tax (%)</th>
            <th>total_stock</th>
            <th>is_active?</th>
            <th className="text-end">Actions</th>
          </tr>
        </thead>
        {/* print json products */}
        {/* <pre>{JSON.stringify(products, null, 2)}</pre> */}
        <tbody>
          {products.length > 0 ? (
            products.map((product, index) => (
              <tr key={product.id}>
                <td>{index + 1}</td>
                <td>
                  <img
                    src={product.menu_url || "/images/default-product.png"}
                    alt={product.name}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                </td>
                <td>{product.name}</td>
                {/* <td>{product.category}</td> */}
                {/* categories.map */}
                <td>
                  {product.categories?.map((category, index) => (
                    <span key={index} className="badge me-1">
                      {category.name}
                    </span>
                  ))}
                </td>
                <td>{formatPrice(product.min_price)}</td>
                <td>{formatPrice(product.price)}</td>
                <td>{product.tax_percent || 0}%</td>
                <td>{formatNumber(product.total_stock)}</td>
                {/* <td>{product.is_active ? "Active" : "Inactive"}</td> */}
                <td>
                  {product.is_active ? (
                    <span className="badge bg-success-lt">Active</span>
                  ) : (
                    <span className="badge bg-danger-lt">Inactive</span>
                  )}
                </td>
                <td className="text-end">
                  <Dropdown>
                    <Dropdown.Toggle variant="default">Actions</Dropdown.Toggle>
                    <Dropdown.Menu>
                      {/* Tambah stok */}
                      <Dropdown.Item
                        onClick={(e) => handleAddStock(e, product)}
                      >
                        <IconPlus className="me-2" /> Add Stock
                      </Dropdown.Item>

                      {/* Kurangi stok */}
                      <Dropdown.Item
                        onClick={(e) => handleReduceStock(e, product)}
                      >
                        <IconMinus className="me-2" /> Reduce Stock
                      </Dropdown.Item>
                      {/* Edit */}
                      <Dropdown.Item onClick={(e) => onEdit(e, product)}>
                        <IconEdit className="me-2" /> Edit
                      </Dropdown.Item>
                      <PermissionMiddleware
                        allowedPermissions={["menu_update"]}
                      >
                        {/* Riwayat detail (belum aktif) */}
                        <Dropdown.Item
                          onClick={(e) => {
                            handleDetailHistory(e, product);
                          }}
                        >
                          <IconDetails className="me-2" /> Detail History
                        </Dropdown.Item>

                        {/* Hapus */}
                        <Dropdown.Item onClick={() => onDelete(product.id)}>
                          <IconTrash className="me-2" /> Delete
                        </Dropdown.Item>
                      </PermissionMiddleware>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="mt-4 text-center">{Pagination}</div>
    </div>
  );
};

export default ProductTable;
